import { ref } from "vue";
import {
    fetchLogoutPlayerBoard,
    fetchLogoutDefaultDraw,
    fetchLogoutAllwynDraw,
    fetchLogoutQuests,
} from "../api/bonusomat-logout-data-api";
import { BonusomatAllwynDraw } from "../models/bonusomat-draw";
import { BonusomatLogoutBoard } from "../models/bonusomat-logout-board";
import { BonusomatLogoutDefaultDraw } from "../models/bonusomat-logout-draw";
import { BonusomatLogoutQuest } from "../models/bonusomat-logout-quest";

/* ******************************* BOARD **************************** */
//#region BOARD

// BOARD variables
const logoutBoardData = ref<BonusomatLogoutBoard>(null);
const isLogoutBoardDataLoaded = ref(false);

// BOARD metods
async function loadBoardData() {
    try {
        logoutBoardData.value = await fetchLogoutPlayerBoard();
    } finally {
        isLogoutBoardDataLoaded.value = true;
    }
}
//#endregion

/* **************************** RAFFLE ********************** */
//#region RAFFLE

const logoutDefaultDrawData = ref<BonusomatLogoutDefaultDraw>(null);
const isLogoutDefaultDrawDataLoaded = ref(false);
const logoutAllwynDrawData = ref<BonusomatAllwynDraw>(null);
const isLogoutAllwynDrawDataLoaded = ref(false);

async function loadDefaultDrawData() {
    try {
        logoutDefaultDrawData.value = await fetchLogoutDefaultDraw();

        if (logoutDefaultDrawData.value) {
            const endDate = new Date(logoutDefaultDrawData.value.endDate);
            const now = new Date();
            logoutDefaultDrawData.value.drawDate = new Date(logoutDefaultDrawData.value.drawDate);
            logoutDefaultDrawData.value.endDate = endDate;

            setTimeout(() => {
                logoutDefaultDrawData.value.drawRemainingSeconds = Math.floor(
                    (endDate.getTime() - now.getTime()) / 1000
                );
            }, 1500);
        }
    } catch {
        logoutDefaultDrawData.value = null;
    } finally {
        isLogoutDefaultDrawDataLoaded.value = true;
    }
}

async function loadLogoutAllwynDrawData() {
    try {
        logoutAllwynDrawData.value = await fetchLogoutAllwynDraw();

        if (logoutAllwynDrawData.value) {
            const endDate = new Date(logoutAllwynDrawData.value.endDate);
            const now = new Date();
            logoutAllwynDrawData.value.endDate = endDate;

            setTimeout(() => {
                logoutAllwynDrawData.value.drawRemainingSeconds = Math.floor(
                    (endDate.getTime() - now.getTime()) / 1000
                );
            }, 1500);
        }
    } catch {
        logoutAllwynDrawData.value = null;
    } finally {
        isLogoutAllwynDrawDataLoaded.value = true;
    }
}

//#endregion

/* **************************** QUESTS ************************ */
//#region QUESTS

// QUEST variables
const logoutQuestsData = ref<BonusomatLogoutQuest[]>(null);
const isLogoutQuestsDataLoaded = ref(false);

// QUESTS metods
async function loadQuests() {
    try {
        logoutQuestsData.value = await fetchLogoutQuests();
    } finally {
        isLogoutQuestsDataLoaded.value = true;
    }
}

//#endregion

/* ************************** INIT **************************** */
//#region INIT

async function loadMainData() {
    const boardPromise = loadBoardData();
    const defaultDrawDataPromise = loadDefaultDrawData();
    const allwynDrawDataPromise = loadLogoutAllwynDrawData();
    const questsPromise = loadQuests();

    await Promise.all([boardPromise, defaultDrawDataPromise, allwynDrawDataPromise, questsPromise]);
}

async function initBonusomatLogoutData() {
    await loadMainData();
}

//#endregion

export default function useBonusomatLogoutData() {
    return {
        initBonusomatLogoutData,

        logoutBoardData,
        isLogoutBoardDataLoaded,
        loadBoardData,

        logoutDefaultDrawData,
        logoutAllwynDrawData,
        isLogoutDefaultDrawDataLoaded,
        isLogoutAllwynDrawDataLoaded,
        loadDefaultDrawData,
        loadLogoutAllwynDrawData,

        logoutQuestsData,
        isLogoutQuestsDataLoaded,
        loadQuests,
    };
}
